import React from 'react';
import PropTypes from 'prop-types';
import lodash from 'lodash';
import {connectToStores} from 'epic-alt-utils/index';
import TutorialStore from '../../stores/TutorialStore';
import HeaderBanner from '../../components/common/HeaderBanner';
import TutorialLink from '../../components/tutorial/TutorialLink';
import TutorialMod from '../../components/tutorial/TutorialMod';
import MetaTags from '../../components/common/MetaTags';

@connectToStores
export default class ModTutorialView extends React.Component {
    constructor(props) {
        super(props);
        if (!props.tutorialStore) return;
        this.state = {
            searchResult: null
        }
    }
    static propTypes = {
        tutorialStore: PropTypes.object //eslint-disable-line
    };
    static getStores() {
        return [TutorialStore];
    }

    static getPropsFromStores() {
        return {
            tutorialStore: TutorialStore.getState()
        };
    
    }

    renderList = (list) => {
        return Object.entries(list).map(([key, data]) => {
            return <TutorialMod data={data} key={key} type={key.toLowerCase()} />
        })
    }

    render() {
        const pageData = this.props.tutorialStore || {};
        const {modTutorial = {}, modTutorialList = []} = pageData;
        const sortList = [...modTutorialList].sort((a, b) => a.tutorial.orderNumber - b.tutorial.orderNumber);
        const tutorialList = lodash.groupBy(sortList, (item) => item.tutorial.type);
        const {description, headerImage, title, quickLinks = {}} = modTutorial;
        const {quickLink = []} = quickLinks;

        return (
            <div className="mod-tutorial-view">
                <MetaTags meta={{title: modTutorial._title}} />
                <HeaderBanner title={title} image={headerImage} content={description}>
                    <TutorialLink data={quickLink} />
                </HeaderBanner>
                <div className="content-container">
                    {this.renderList(tutorialList)}
                </div>
            </div>
        );
    }
}
